const getGoVisaState = ({ goVisaState }) => goVisaState;

export { getGoVisaState };
